// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import { withRouter } from 'react-router';
import MainMenu from '../components/MainMenu';

const MainMenuContainer = withRouter(MainMenu);

export default MainMenuContainer;